import { Alert, Grid } from "@mui/material";
import ScrollableFlexContainer from "../../../../../../shared/components/ScrollableFlexContainer";
import useDeferredDictionaryLoading from "../../../../../../shared/reporting/components/viewer/common/hooks/useDeferredDictionaryLoading";
import { useBiCommonDataContext } from "../../../../../../shared/reporting/contexts/BiCommonDataContext";
import { IrrDrillDownInfo } from "../../../../../api/biApi.types";
import useDrillDown from "../../../../../hooks/useDrillDown";
import { DrillDownPage } from "../../../../../store/types/drillDownPageState.types";
import CollapseContainer from "../../../../common/CollapseContainer";
import useCommonReportHandlers from "../../hooks/useCommonReportHandlers";
import ConditionsCollapsedHeader from "../ConditionsCollapsedHeader";
import ReadonlyConditions from "../ReadonlyConditions";
import { CashFlowGrid } from "./CashFlowGrid";
import ToolBar from "./ToolBar";

export interface Props {
  configuration: DrillDownPage;
  info: IrrDrillDownInfo;
}

export default function CashFlowPart({ configuration, info }: Props) {
  const state = useDrillDown(info);
  const handlers = useCommonReportHandlers();

  const { dataSetId } = useBiCommonDataContext();
  useDeferredDictionaryLoading(
    dataSetId,
    { values: state.conditions, updateItem: state.actions.updateCondition },
    handlers.onLoadDictionaries
  );

  return (
    <Grid container sx={{ position: "relative", flexDirection: "row", width: "100%" }}>
      <CollapseContainer collapseElement={<ConditionsCollapsedHeader conditionsCount={state.conditions.length} />}>
        <Grid
          sx={(theme) => ({
            flex: 1,
            maxWidth: 340,
            width: "100%",
            p: "1.3rem",
            pl: 3,
            borderRight: "1px solid " + theme.palette.divider,
          })}
        >
          <ReadonlyConditions state={state} configuration={configuration} info={info} />
        </Grid>
      </CollapseContainer>
      <Grid container sx={{ flex: 1, width: "unset", flexDirection: "column" }}>
        <Grid container sx={{ flex: 1, width: "unset", flexDirection: "column", pl: "1.3rem", py: 2, pr: 3, gap: 2 }}>
          <ToolBar configuration={configuration} info={info} />
          {state.error && (
            <Alert sx={{ mb: ".5rem" }} severity="error">
              {state.error}
            </Alert>
          )}
          <ScrollableFlexContainer scrollContainerSx={{ mb: 1 }}>
            <CashFlowGrid configuration={configuration} info={info} />
          </ScrollableFlexContainer>
        </Grid>
      </Grid>
    </Grid>
  );
}
